import React from 'react';

export const AVAILABLE_ICONS = Object.freeze({
    clock: 'glyphicon glyphicon-time',
    delete: 'glyphicon glyphicon-trash',
    document: 'glyphicon glyphicon-file',
    down: 'glyphicon glyphicon-arrow-down',
    edit: 'glyphicon glyphicon-pencil',
    expired: 'glyphicon glyphicon-time',
    folder: 'glyphicon glyphicon-folder-open',
    'folder-thin': 'far fa-folder',
    image: 'glyphicon glyphicon-picture',
    plus: 'glyphicon glyphicon-plus',
    remove: 'glyphicon glyphicon-remove',
    times: 'fa fa-times',
    trash: 'glyphicon glyphicon-trash',
    up: 'glyphicon glyphicon-arrow-up',
    video: 'glyphicon glyphicon-facetime-video',
} as const);

export type IconProps = {
    title?: string;
    icon: keyof typeof AVAILABLE_ICONS;
    className?: string;
    style?: React.CSSProperties;
};

export const Icon: React.FunctionComponent<IconProps> = ({ className, icon, ...props }) => (
    <i className={`${AVAILABLE_ICONS[icon]} ${className ?? ''}`} {...props} />
);
Icon.displayName = 'Icon';
